// extracted by mini-css-extract-plugin
export default {"currency":"lkKeH","info":"bHWCQ","info__title":"A3oTk","row":"mGI2g"};